import { defineMessages } from 'react-intl';

export const scope = 'loop.containers.News.Details.Messages';

export default defineMessages({
  SimilarEvents: {
    id: `${scope}.similarEvents`,
    defaultMessage: 'Slični događaji',
  },
  NoSimilarEvents: {
    id: `${scope}.noSimilarEvents`,
    defaultMessage: 'Nema sličnih događaja',
  },
  ShowAllEvents: {
    id: `${scope}.showAllEvents`,
    defaultMessage: 'Prikaži sve događaje iz ove kategorije',
  },
  ShareEvent: {
    id: `${scope}.shareEvent`,
    defaultMessage: 'Podeli događaj',
  },
  EventSignUp: {
    id: `${scope}.eventSignUp`,
    defaultMessage: 'Prijavi se na događaj',
  },
  EventVenue: {
    id: `${scope}.eventVenue`,
    defaultMessage: 'Mesto održavanja',
  },
  EventTime: {
    id: `${scope}.eventTime`,
    defaultMessage: 'Vreme održavanja',
  },
  EventRegFee: {
    id: `${scope}.eventRegFee`,
    defaultMessage: 'Kotizacija',
  },
  EventCity: {
    id: `${scope}.eventCity`,
    defaultMessage: 'Grad',
  },
  EventAddress: {
    id: `${scope}.eventAddress`,
    defaultMessage: 'Adresa',
  },
  EventDate: {
    id: `${scope}.eventDate`,
    defaultMessage: 'Datum održavanja',
  },
  EventType: {
    id: `${scope}.eventType`,
    defaultMessage: 'Vrsta događaja',
  },
  EventMaxAttend: {
    id: `${scope}.eventMaxAttend`,
    defaultMessage: 'Maksimum učesnika',
  },
  EventPublished: {
    id: `${scope}.eventPublished`,
    defaultMessage: 'Događaj objavljen',
  },
  EventPublish: {
    id: `${scope}.eventPublish`,
    defaultMessage: 'Događaj objavljuje',
  },
  Category: {
    id: `${scope}.category`,
    defaultMessage: 'Kategorija',
  },
  AdForJob: {
    id: `${scope}.adForJob`,
    defaultMessage: 'Tražite radnike? Želite da postavite oglas za posao?',
  },
  ClickHere: {
    id: `${scope}.clickHere`,
    defaultMessage: 'Kliknite OVDE',
  },
  Events: {
    id: `${scope}.events`,
    defaultMessage: 'Događaji',
  },
  Payment: {
    id: `${scope}.payment`,
    defaultMessage: 'Plaćanje',
  },
  EventExpired: {
    id: `${scope}.eventExpired`,
    defaultMessage: 'Događaj je prošao!',
  },
});
